import {
  Grid,
  Container,
  Paper,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import logo from "../Assets/login/RockkpayLogo.png";
import { Colors } from "../Reports/Colors";

const styles = {
  container: {
    padding: "1rem",
    width: "100%",
    maxWidth: "1000px",
    boxSizing: "border-box",
    backgroundColor: "#f0f0f0",
    minHeight: "90vh",
  },
  paper: {
    padding: "2rem",
    backgroundColor: Colors.bgColor,
    boxSizing: "border-box",
    color: Colors.textColor,
  },
  header: {
    display: "flex",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "-2%",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "6%",
  },
  tableHeadCell: {
    fontWeight: "bold",
    fontSize: "10px",
    color: Colors.textColor,
  },
  footerText: {
    fontSize: "12px",
    color: Colors.textColor,
  },
};

const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString() || "N/A";
const formatTime = (dateString) =>
  new Date(dateString).toLocaleTimeString() || "N/A";

const ReverseMoneyInvoice = ({ data }) => {
  const userID = sessionStorage.getItem("userId");
  const userName = sessionStorage.getItem("username");
  const userType = sessionStorage.getItem("uType");

  if (!data) return null;

  return (
    <Container style={styles.container}>
      <Paper elevation={3} style={styles.paper}>
        <Grid style={styles.header}>
          <Typography>Reverse Money Receipt</Typography>
        </Grid>

        <Grid style={{ marginTop: "1%" }}>
          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid>
              <Grid
                style={{ display: "flex", alignItems: "center", gap: "6%" }}
              >
                <img
                  src={logo}
                  alt="RockkPay Logo"
                  style={{
                    height: 65,
                    width: 65,
                    backgroundColor: "transparent",
                    borderRadius: "50%",
                  }}
                />
                <Typography style={{ fontWeight: "bold", fontSize: "28px" }}>
                  RockkPay
                </Typography>
              </Grid>
              <Grid style={{ marginTop: "2%" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "start",
                  }}
                >
                  {formatDate(data.dt) || "N/A"}
                </Typography>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "start",
                  }}
                >
                  {formatTime(data.dt) || "N/A"}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              style={{ display: "flex", alignItems: "center", marginTop: "3%" }}
            >
              <Grid style={{ textAlign: "end" }}>
                <Typography style={{ fontSize: "16px", fontWeight: "bold" }}>
                  From :
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {data.receiverName || "N/A"}
                </Typography>
                <Typography style={{ fontSize: "16px" }}>
                  {data.receiverId || "N/A"}
                </Typography>
                {/* <Typography style={{ fontSize: '14px' }}>{formatAddress(data.sender_address)}</Typography> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "3%",
            }}
          >
            <Grid style={{ textAlign: "start" }}>
              <Typography style={{ fontSize: "16px", fontWeight: "bold" }}>
                To :
              </Typography>
              {userType === "ADMIN" ? (
                <Typography variant="body1">{userName}</Typography>
              ) : (
                <Grid>
                  <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
                    RockkPay Admin
                  </Typography>
                  <Typography variant="body1">{data.reverseBy}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          <TableContainer style={{ marginTop: "5%" }}>
            <Table
              aria-label="transaction table"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <TableHead>
                <TableRow>
                  {[
                    "Txn ID",
                    "Receiver ID",
                    "Reversed By",
                    "Receiver Name",
                    "User Type",
                    "Amount",
                    "Status",
                  ].map((header, index) => (
                    <TableCell key={index} style={styles.tableHeadCell}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.tId || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.receiverId || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.reverseBy || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.receiverName || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.utype || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.amount || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "10px", color: Colors.textColor }}
                  >
                    {data.status || "N/A"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            style={{
              marginTop: "4%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold", fontSize: "22px" }}>
                EDSOM FINTECH PRIVATE LIMITED
              </Typography>
              <Typography style={{ fontWeight: "bold", fontSize: "14px" }}>
                Thank you for transacting at RockkPay!
              </Typography>
              <Typography
                color="textSecondary"
                style={{ fontSize: "12px", color: Colors.textColor }}
              >
                This is a system generated receipt hence does not require any
                signature.
              </Typography>
              <Typography
                color="textSecondary"
                style={{ fontSize: "12px", color: Colors.textColor }}
              >
                Queries? Write to care@rockkpay.co.in
              </Typography>
            </Grid>
            <Grid>
              <Divider />
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>
                  Total Amount: {data.amount}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ReverseMoneyInvoice;
